import cn from "classnames";

export const SiteHeaderNavAnimatedUnderline = ({
  showWhenOpen = false,
  borderClassName = "border-promo-black",
}: SiteHeaderNavAnimatedUnderlineProps) => (
  <span
    aria-hidden
    data-testid="site-header-nav-animated-underline"
    className={cn(
      "absolute right-0 left-0 bottom-4 border-2 opacity-0 transition-all duration-500",
      borderClassName,
      "group-hover:translate-y-4 group-hover:opacity-100",
      showWhenOpen &&
        "group-open/details:translate-y-4 group-open/details:opacity-100",
    )}
  />
);

export type SiteHeaderNavAnimatedUnderlineProps = {
  showWhenOpen?: boolean;
  borderClassName?: string;
};
